module.exports = __webpack_public_path__ + "static/media/age.57df4fd3.svg";